module.exports = require('./dist/Tooltip.js');



//////////////////
// WEBPACK FOOTER
// ./~/dibs-react-tooltip/index.js
// module id = 276
// module chunks = 5 7 8 9 10 11 12 13 14 15 16 17 18 19 21 22 23 24 27 31 32 33 57 58